<template>
    <div class="relative text-base group sm:text-sm">
        <div class="p-1 overflow-hidden group-hover:opacity-75">
            <a :href="`/${opportunity.id}/${opportunity.slug}`" :title="opportunity.title">
                <div class=" aspect-3/2 opp-img guide-img-container">
                    <img class="object-cover rounded-lg shadow-lg aspect-3/2" :src="opportunity.imageUrl" :alt="opportunity.title"
                        :title="opportunity.title">
                </div>
            </a>
        </div>
        <dl class="flex flex-col px-1 mt-3 ">
            <dd class="mt-1 text-xs" :title="opportunity.regionName">
                {{ opportunity.regionName }}
            </dd>
            <dt class="sr-only">Category</dt>
            <dd class="mt-2">
                <span class="px-2 py-1 mb-2 text-sm text-gray-900 rounded-md bg-slate-100">
                    {{ opportunity.category }}
                </span>
            </dd>

            <div v-if="opportunity.isPostedByProMember" class="hidden py-2 text-sm text-gray-600 md:col-span-2">
                <LightBulbIcon class="w-5 h-5 text-sa-red-600" /> Pro Posted!
            </div>
        </dl>
        <a :href="`/${opportunity.id}/${opportunity.slug}`" :title="opportunity.title"
            class="block px-1 mt-2 font-medium hover:underline">
            <h3 class="">{{ opportunity.title }}</h3>
        </a>


    </div>

</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import {OpportunityDTOLightweight} from "@/dtos";
import {LightBulbIcon} from "@heroicons/vue/20/solid";

const props = defineProps<{
    opportunity: OpportunityDTOLightweight,
}>();

const opportunity = props.opportunity;
</script>
<style>

</style>